import {getRequest, URL_SERVER} from './../requests'


export async function getAvatars(token){
    try {
        return await getRequest(URL_SERVER + '/avatars', token)
    } catch (error) {
        console.error(error);
    }
}